/**
 * @component CompanyGreetingsPage
 * @description 새힘정보기술 인사말 페이지입니다.
 * @usage App 라우팅에서 `/company/ceo.html` 경로로 렌더링됩니다.
 */

import PageHero from '../../components/common/PageHero';
import Text from '../../content/Text';
import { useContentList } from '../../content/useContent';
import { pageMeta } from '../../constants/navigation';

// [비즈니스] 본문 문단은 관리자가 추가·삭제·순서 변경할 수 있는 가변 목록입니다.
//            개수를 페이지에 고정하지 않고 콘텐츠 한 키에서 목록을 통째로 받습니다.
const PARAGRAPH_KEY = 'company.ceo.letter.paragraphs';

// [기능] 기존 인사말 구조에 레지스트리 문구와 가변 문단 목록을 렌더합니다.
export default function CompanyGreetingsPage() {
  const paragraphs = useContentList(PARAGRAPH_KEY);
  return (
    <>
      <PageHero
        title={pageMeta.companyCeo.title}
        trail={pageMeta.companyCeo.trail}
        className="company-page-hero"
      />

      <section className="section ceo-greeting-page">
        <div className="container">
          <div className="ceo-greeting-layout">
            <article className="ceo-letter fade-in">
              <span className="ceo-letter-eyebrow">
                <Text contentKey="company.ceo.letter.eyebrow" />
              </span>
              <h2>
                <Text contentKey="company.ceo.letter.headingLine1" />
                <br />
                <Text contentKey="company.ceo.letter.headingLine2" />
              </h2>
              <p className="ceo-letter-lead">
                <Text contentKey="company.ceo.letter.lead" />
              </p>

              <div className="ceo-message-body">
                {/* [기능] 저장된 순서대로 문단을 렌더합니다. */}
                {/* [기술] 고유 식별자가 없어 index를 key로 쓰며 같은 문구의 중복 key를 피합니다. */}
                {paragraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>

              <div className="ceo-letter-footer">
                <div>
                  <span>
                    <Text contentKey="company.ceo.letter.signature" />
                  </span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}
